const header = [
  { text: 'start_date', value: 'start_date' },
  { text: 'end_date', value: 'end_date' },
  { text: 'start_time', value: 'start_time' },
  { text: 'end_time', value: 'end_time' },
  { text: 'recurring', value: 'recurring' },
  { text: 'weight', value: 'weight' },
  { text: 'total_allotted', value: 'total_allotted' },
  { text: 'remaining_allotted', value: 'remaining_allotted' }
]

export default header
